import { Directive, HostListener, Input } from "@angular/core";

@Directive({
  selector: "[appPasswordTouchToggle]",
  standalone: true,
})
export class NxPasswordTouchToggleDirective {
  @Input("appPasswordTouchToggle") public target;

  @HostListener("mousedown") protected onMouseDown() {
    this.target.toggleInputType("text");
  }

  @HostListener("touchstart") protected onTouchStart() {
    this.target.toggleInputType("text");
    setTimeout(() => {
      this.target.toggleInputType("text");
    }, 500);
  }
}
